import { SVGProps } from "react";

export function LockIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.8333 8.33366H16.6667C17.1269 8.33366 17.5 8.70674 17.5 9.16699V17.5003C17.5 17.9606 17.1269 18.3337 16.6667 18.3337H3.33333C2.8731 18.3337 2.5 17.9606 2.5 17.5003V9.16699C2.5 8.70674 2.8731 8.33366 3.33333 8.33366H4.16667V7.50033C4.16667 4.27867 6.77834 1.66699 10 1.66699C13.2217 1.66699 15.8333 4.27867 15.8333 7.50033V8.33366ZM4.16667 10.0003V16.667H15.8333V10.0003H4.16667ZM9.16667 11.667H10.8333V15.0003H9.16667V11.667ZM14.1667 8.33366V7.50033C14.1667 5.19914 12.3012 3.33366 10 3.33366C7.69882 3.33366 5.83333 5.19914 5.83333 7.50033V8.33366H14.1667Z"
        fill="#7A7A7A"
      />
    </svg>
  );
}
